<template>
    <v-dialog ref="dialog" v-model="display" :return-value.sync="time" persistent width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field v-model="time" :label="label" prepend-icon="access_time" readonly v-on="on"></v-text-field>
        </template>
        <v-time-picker v-if="display" v-model="time" full-width format="24hr">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="display = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
        </v-time-picker>
    </v-dialog>
</template>

<script>
export default {
    name: 'v-time-picker',
    model: {
        prop: 'time',
        event: 'input',
    },
    props: {
        // time: {
        //     type: [String],
        //     default: null,
        // },
        label: {
            type: String,
            default: '',
        },
        width: {
            type: Number,
            default: 320,
        },
        format: {
            type: String,
            default: 'HH:mm',
        },
        timePickerFormat: {
            type: String,
            default: '24hr',
        },
        locale: {
            type: String,
            default: 'en-us',
        },
        clearText: {
            type: String,
            default: 'CLEAR',
        },
        okText: {
            type: String,
            default: 'OK',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: () => [],
        },
        errorCount: {
            type: [Number, String],
            default: 1,
        },
        error: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: Boolean,
            default: false,
        },
        appendIcon: {
            type: String,
            default: null,
        },
        prependIcon: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            display: false,
            // time: null,
        };
    },
    computed: {},
    created() {},
    methods: {},
};
</script>
